import "../css/index.css";
import initNavigation from "./navigation";
import initAnimations from "./animations";
import initArchive from "./archive";
import initSearch from "./search";
import initTheme from "./theme";

initNavigation();
initAnimations();
initArchive();
initSearch();
initTheme();
